import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { ReCaptchaV3Service } from 'ngx-captcha';

import { SiteVerify } from '../../model/site.verify';
import { CONFIG } from '../../constants/constants';
import { WhiteListDTO } from '../../model/witheList.dto';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaV3Service {
  /** Score: puntuación que da google al usuario */
  private score?: boolean;

  constructor(private reCaptchaV3Service: ReCaptchaV3Service, private http: HttpClient) { }

  /** Método encargado de ejecutar el recaptcha V3 */
  public execute(action: string, ip: string): Promise<string> {  
    var promise = new Promise<string>((resolve, reject) => {
      this.reCaptchaV3Service.execute(CONFIG.SITE_KEY, action, (token) => {
        resolve(token);
      });
    });
    return promise;
  }

  /** Método encargado de solicitar el score al servicio de Google */
  private getSiteVerify(token: string): Promise<SiteVerify> {
    return this.http.get<SiteVerify>(CONFIG.SITE_VERIFY + token).toPromise();
  }

  /** Método encargado de obtener el score */
  public getScore() {
    return this.score;
  }
}
